import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import inquiryService from '@root/modules/Warehouse/Inquiry/service/inquiry';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Spin, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import WrapAction from './wrap-action';
// import { saveAs } from "file-saver";

interface DataTypeWare {
  id: React.Key;
  sellerName: string;
  sellerEmail: string;
  productName: string;
  status: string;
  updatedAt: string;
}

function TableInquiry({ listInquiry, setListInquiry }: any) {
  const [totalPages, setTotalPages] = useState(1);
  // const [filterDate, setFilterDate] = useState<[string, string]>();
  // const fromDt: string = (filterDate && filterDate[0]) || '';
  // const toDt: string = (filterDate && filterDate[1]) || '';
  const [page, setPage] = useState(1);
  const [searchBy, setSearchBy] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [listData, setListData] = useState([]);
  const [labelSelect, setLabelSelect] = useState({
    key: '1',
    label: 'Select'
  } as any);
  const [t] = useTranslate();
  const [listExcel, setListExcel] = useState([] as any);
  const history = useHistory();
  const [filter, setFilter] = useState([] as any);
  const [query, setQuery] = useState();
  const [filterDate, setFilterDate] = useState<[string, string]>();
  const fromDt: string = (filterDate && filterDate[0]) || '';
  const toDt: string = (filterDate && filterDate[1]) || '';
  const [sort, setSort] = useState(true);
  const [loading, setLoading] = useState(false);

  const [isSearch, setIsSearch] = useState('');

  const columns: ColumnsType<DataTypeWare> = [
    {
      title: 'No',
      dataIndex: 'id'

      // key: 'index',
      // render: (text, record, index) => index + 1
    },
    {
      title: 'Company Name',
      dataIndex: 'companyName'
    },
    {
      title: 'Seller email address',
      dataIndex: 'sellerEmail'
    },
    {
      title: 'Product name',
      render: (row) => {
        return (row.products && row.products.length) ? row.products[0].productName : '';
      }
    },
    {
      title: 'Status',
      dataIndex: 'status'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(true);
                setPage(1);
              }}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '10px' }}
              onClick={() => {
                setSort(false);
                setPage(1);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt'
    }
    // {
    //   title: "Update day",
    //   dataIndex: "updatedAt",
    //   // sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
    // },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataTypeWare[]) => {
      setListExcel(selectedRows);
      console.log(selectedRows, 'selectedRows');
    },
    getCheckboxProps: (record: DataTypeWare) => ({
      disabled: record.productName === 'Disabled User',
      name: record.productName
    })
  };

  /*---------------------------get id-----------------------------*/

  const redirect = (myKey: any) => {
    history.push(`/another_page/${myKey}`);
  };

  /*--------------------------search-----------------------------*/

  useEffect(() => {
    setFilter(listInquiry.filter((a: any) => a.productName.includes(query)));
    // setFilter(serach[0]);
  }, [query]);

  /*----------------------excel---------------------------------*/

  const idMap = listExcel.map((item: any) => item.key);

  const arrId = {
    ids: idMap
  };

  const handleOnExport = async () => {
    if (listExcel.length > 0) {
      const response = await inquiryService.postDownExcelId(arrId);
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Inquiry_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      // const response = await inquiryService.postDownExcelId(arrId);
      // const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      // const outputFilename = `Inquiry_ ` + utc + `.xlsx`;
      // const url = URL.createObjectURL(new Blob([response]));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', outputFilename);
      // document.body.appendChild(link);
      // link.click();
      const response = await inquiryService.postDownExcel(
        fromDt,
        toDt,
        searchBy,
        valueSearch,
        sort
      );
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Inquiry_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };
  /*-------------------------------paging---------------------------------*/

  //Handle pagination
  const getSelect = (e: any) => {
    setSearchBy(e.key);
    setLabelSelect({ key: e.key, label: e.domEvent.target.innerText });
  };
  const handelPagination = async (
    page: number,
    fromDt: string,
    toDt: string,
    searchBy: string,
    filterInput: string,
    sort: boolean
  ) => {
    setLoading(true);
    const res = await inquiryService.getPagination(
      page,
      fromDt,
      toDt,
      searchBy,
      filter,
      filterInput,
      sort
    );
    setTotalPages(res.count);
    const rowData = res.data?.map((row: any) => {
      let statusFix =
        row.status === 'SellerApproved'
          ? 'Approval'
          : row.status === 'WarehouseApproved'
          ? 'Approval'
          : row.status === 'Rejected'
          ? 'Reject'
          : row.status === 'New'
          ? 'New'
          : '';
      return {
        ...row,
        key: row.id,
        updatedAt: formatDateTime(row.updatedAt),
        status: statusFix
      };
    });

    setListData(rowData);
    setLoading(false);
  };

  useEffect(() => {
    if (!!valueSearch && !!setSearchBy) setIsSearch(valueSearch);
    else if (!!isSearch && !valueSearch) {
      setIsSearch('');
      setPage(1);
    }
  }, [debounc, setSearchBy]);

  useEffect(() => {
    handelPagination(1, fromDt, toDt, searchBy, valueSearch, sort);
    setPage(1);
  }, [isSearch, fromDt, toDt, sort, searchBy]);
  // }, [page, searchBy, debounc, fromDt, toDt, sort]);

  const onChangeSearch = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDateValue = (value: [string, string]) => {
    setFilterDate(value);
    setPage(1);
  };
  // const SearchName = () => {
  //   handelPagination(1, fromDt, toDt, searchBy, valueSearch, sort);
  //   setPage(1);
  // };

  return (
    <Spin spinning={loading} className="loading-forgot">
      <div className="wrapTableList">
        <WrapAction
          getSelect={getSelect}
          labelSelect={labelSelect}
          onChangeSearch={onChangeSearch}
          getDateValue={getDateValue}
          // onSearchName={SearchName}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '15px 17px',
            background: 'white',
            alignItems: 'center'
          }}
        >
          <div>
            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              Total inquiry {totalPages}
            </span>
            <div
              className="ant-divider ant-divider-vertical"
              role="separator"
            ></div>
            <span style={{ marginLeft: '8px', marginRight: '8px' }}>
              {listExcel.length > 0 ? (
                <span> Select inquiry {listExcel.length}</span>
              ) : (
                <span>Select inquiry 00</span>
              )}
            </span>
          </div>

          <div>
            <Button
              className="downExcel"
              onClick={() => {
                handleOnExport();
              }}
            >
              Download Excel
            </Button>
          </div>
        </div>

        <Table
          className="warehouse-table"
          columns={columns}
          dataSource={listData}
          rowSelection={rowSelection}
          pagination={{
            total: totalPages,
            current: page,
            onChange: (page, limit) => {
              setPage(page);

              handelPagination(page, fromDt, toDt, searchBy, valueSearch, sort);
            }
          }}
          onRow={(item) => {
            return {
              onClick: () => {
                history.push(`/admin/inquiry/${item.id}`);
              }
            };
          }}
        />
      </div>
    </Spin>
  );
}

export default TableInquiry;
